import { render } from "./AddAutomationController.vue?vue&type=template&id=1aadb314&scoped=true"
import script from "./AddAutomationController.vue?vue&type=script&lang=js"
export * from "./AddAutomationController.vue?vue&type=script&lang=js"

import "./AddAutomationController.vue?vue&type=style&index=0&id=1aadb314&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aadb314"]])

export default __exports__